import { WprBaseViewInfo } from '../../wpr-framework/view/WprBaseViewInfo';

/**
 * メインビュー情報
 */
export class MainComponentView extends WprBaseViewInfo {
	// コンストラクタ  -----------------------------------------------------------
	constructor() {
		super('メインビュー');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {}
	// --------------------------------------------------------------------------
}
